import React from 'react'
import type { FC } from 'react'
import { Link as RouterLink } from 'react-router'
import { getPathFromPathOrUrl } from './get-path.js'
import styles from './link.module.css'

export interface LinkProps {
  to: string
  external?: boolean
  children: React.ReactNode
}

export const Link: FC<LinkProps> = ({ to: pathOrUrl, external = false, children }) => {
  const to = external ? pathOrUrl : getPathFromPathOrUrl(pathOrUrl)

  if (external) {
    return (
      <a href={to} className={styles.link}>
        {children}
      </a>
    )
  }

  return (
    <RouterLink to={to} className={styles.link}>
      {children}
    </RouterLink>
  )
}

export default Link
